<template>
  <div class="page">
    <div class="group_1">
      <div class="group_2">
        <!-- 表头 -->
        <van-cell class="table-header" :border="false">
          <div class="col-course1">证书名称</div>
          <div class="col-course1">年度</div>
          <div class="col-hours1">完成学时</div>
          <div class="col-hours1">操作</div>
        </van-cell>

        <!-- 课程列表 -->
        <!-- <van-cell-group> -->
          <div v-if="courses.length>0">
               <van-cell v-for="(course, index) in courses" :key="index" :border="index < courses.length - 1">
          <div class="table-row-content">
            <div class="col-course">{{ course.certName }}</div>
            <div class="col-course">{{course.year}}</div>
            <div class="col-course">{{course.credit}}</div>
            <div>
              <div class="btn" @click="handleZs(course)">查看证书</div>
            <div class="btn" @click="goCertificate(course)" style="margin-top: 5px;">学时证明</div>
            </div>
            
          </div>
        </van-cell> 
          </div>
          <div v-else style="margin-top: 20px;text-align: center;">暂无数据</div>
    
        <!-- </van-cell-group> -->
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getMergeCertList } from '../../api/certificate';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      selectAll: false,
      courses: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getList() {
      getMergeCertList({ classId: this.$route.query.classId }).then(res => {
        this.courses = res.data.data;
      });
    },
    //去查看证书
    handleZs(row){
 this.$router.push({
        path: '/zsCan',
        query: { certId: row.certId }
      });
    },
     goCertificate(item) {
      console.log(item);

      console.log('学时证明');
      this.$router.push({
        path: '/classHour',
        query: { classId: item.classId, userId: item.userId, certId: item.certId}
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.text_1 {
  width: 100%;
  height: 60px;
  background: rgba(255, 100, 100, 0.08);
  border-radius: 8px 8px 8px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ff6464;
  padding: 12px 15px;
}
.group_2 {
  width: 100%;
  margin-top: 15px;
  background-color: #ffffff;
  border-radius: 8px !important;
  padding-bottom: 10px;
  .van-cell {
    // border-radius: 8px !important;
  }
  .van-cell__value {
    display: flex;

    justify-content: space-between;
    // border-bottom: 1px solid #e8e8e8;
  }

  .table-header {
    border-radius: 8px 8px 0 0 !important;

    border-bottom: 1px solid #ebedf0;
    display: flex;
    align-items: center;
    padding: 12px 15px;
    .col-check {
      width: 82px;
      display: flex;
      align-items: center;
    }

    .col-course {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: center;
    }

    .col-hours {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: right;
    }
    .col-course1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #333333;
      text-align: center;
    }

    .col-hours1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #333333;
      text-align: right;
    }
  }

  .table-row-content {
    display: flex;
    align-items: center;
    width: 100%;

    .col-check {
      width: 82px;
      display: flex;
      align-items: center;
    }

    .col-course {
      width: 100px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: center;
    }

    .col-hours {
      width: 103px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: right;
    }
  }
}
.btn {
  width: 68px;
  height: 32px;
  background: rgba(53, 120, 244, 0.06);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #2a70f2;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  text-align: center;
  line-height: 32px;
}
.button-container {
  margin-top: 20px;
}
/deep/.van-checkbox__icon--round .van-icon {
  border-radius: 23% !important;
}
/deep/ .van-cell-group {
  border-bottom: 0 !important;
}
</style>
